export default "__VITE_PUBLIC_ASSET__abeafa7f__"